/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2024 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import * as t from "react";
import { guid as s } from "../guid.mjs";
import { useIsomorphicLayoutEffect as i } from "./use-isomorphic-layout-effect.mjs";
function m(e) {
  const [u, c] = t.useState(!1);
  t.useEffect(() => {
    c(!0);
  }, []);
  const [r, n] = t.useState(() => {
    if (e)
      return e;
    if (u)
      return s();
  });
  i(() => {
    r === void 0 && n(s());
  }, []);
  const o = t[`useId${s()}`.slice(0, 5)];
  if (o !== void 0) {
    const f = o();
    return e != null ? e : f;
  }
  return r;
}
export {
  m as useId
};
